    function createSearchClient() {
        function search(query, cb) {
            // Handle both string queries and object parameters
            const searchParams = {
                query: query.query || query,
                hitsPerPage: query.hitsPerPage || 24,
                page: query.page || 0,
                attributesToRetrieve: query.attributesToRetrieve || [
                    'title',
                    'thumbnail', 
                    'thumbnails',
                    'link',
                    'type',
                    'author',
                    'shortDescription',
                    'subtitle',
                    'initials',
                    'ages',
                    'genres'
                ],
                facets: query.facets || ['ages', 'genres', 'lists', 'type']
            };
            
            // Add filters if provided
            if (query.filters) {
                searchParams.filters = query.filters;
            }
            if (query.facetFilters) {
                searchParams.facetFilters = query.facetFilters;
            }
            
            // Call our server-side search endpoint
            fetch('/api/search', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(searchParams)
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(results => {
                cb(results);
            })
            .catch(onError);
        }
    
        function onError(err) {
            console.error('Search error:', err);
        }
    
        return { search };
    }
    
    export default createSearchClient;
